export default "__VITE_ASSET__CX22sFp6__"